/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  /**
   * All stakeholders
   */
  stakeholders: [],
  stakeholdersBySlug: {},

  // 
  municipalitySlugByGeographyCode: {}
}

const getters = {
  getStakeholders: state => state.stakeholders,

  getMunicipalities: state => state.stakeholders
    .filter(
      stakeholder => stakeholder.category === 'municipality'
    )
    .slice()
    .sort((a, b) => {
      return (a.enabled === b.enabled)
        ? (a.name || '').localeCompare((b.name || ''))
        : (a.enabled === false ? 1 : -1)
    }),
  getContractors: state => state.stakeholders
    .filter(
      stakeholder => stakeholder.category === 'contractor'
    )
    .slice()
    .sort((a, b) => {
      return (a.enabled === b.enabled)
        ? (a.name || '').localeCompare((b.name || ''))
        : (a.enabled === false ? 1 : -1)
    }),
  getGridOperators: state => state.stakeholders
    .filter(
      stakeholder => stakeholder.category === 'gridoperator'
    )
    .slice()
    .sort((a, b) => {
      return (a.enabled === b.enabled)
        ? (a.name || '').localeCompare((b.name || ''))
        : (a.enabled === false ? 1 : -1)
    }),
  getChargePointOperators: state => state.stakeholders
    .filter(
      stakeholder => stakeholder.category === 'cpo'
    )
    .slice()
    .sort((a, b) => {
      return (a.enabled === b.enabled)
        ? (a.name || '').localeCompare((b.name || ''))
        : (a.enabled === false ? 1 : -1)
    }),
  
  hasStakeholderBySlug: state => ({ slug }) => !! (state.stakeholdersBySlug[slug] || false),
  getStakeholderBySlug: state => ({ slug }) => state.stakeholdersBySlug[slug] || null,

  getMunicipalitySlugByGeographyCode: state => ({ code }) => {
    return state.municipalitySlugByGeographyCode[code] || null
  }
}
const actions = {
  async loadStakeholders({ commit }) {
    const response = await this.$cbapi.config.getStakeholders()

    if (! response) {
      // TODO: Improve error handling to us & customer in Vue 3
      console.log("Error while loading stakeholders")

      // This will trigger a 'criticalFailure' check while loading the application
      throw new Error()
    }

    commit('setStakeholders', {
      stakeholders: response.data
    })
  }
}
const mutations = {
  setStakeholders(state, { stakeholders }) {
    state.stakeholders = stakeholders

    state.stakeholdersBySlug = stakeholders.reduce((acc, stakeholder) => {
      acc[stakeholder.slug] = stakeholder
      return acc
    }, {})

    /**
     * Map Municipality stakeholders by their geography code
     */
    state.municipalitySlugByGeographyCode = stakeholders
      .filter(stakeholder => stakeholder.category === 'municipality')
      .reduce((acc, stakeholder) => {
        let code = stakeholder.slug.split('-').reverse()[0]
        acc[code] = stakeholder.slug
        return acc
      }, {})
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
